import { forwardRef, Ref } from 'react';

import { styled } from '@mui/material';

import Button, { Props as ButtonProps } from '../../../components/Button';
import { inputBaseClasses } from '../../../components/FormControls/TextFieldBase/styles';
import PasswordTextField from '../../../components/HookFormControls/PasswordTextField';

export const StyledPasswordTextField = styled(PasswordTextField)(({ theme }) => ({
  [`& .${inputBaseClasses.root}`]: {
    backgroundColor: theme.palette.grey[50],
  },
  [`& .${inputBaseClasses.input}`]: {
    fontSize: theme.typography.pxToRem(14),
  },
})) as typeof PasswordTextField;

export const BackButton = styled(
  forwardRef((props: ButtonProps, ref: Ref<HTMLButtonElement>) => (
    <Button variant="outlined" {...props} ref={ref} />
  ))
)(() => ({
  minWidth: 92,
}));

export const LoginButton = styled(
  forwardRef((props: ButtonProps, ref: Ref<HTMLButtonElement>) => (
    <Button variant="contained" {...props} ref={ref} />
  ))
)(() => ({
  flex: 1,
}));
